
import { Link } from 'react-router-dom';

export default function IntroSection() {
  return (
    <div className="prose prose-lg max-w-none mb-16">
      <p className="text-xl text-gray-700 leading-relaxed mb-6">
        If you own a small business in <strong>El Paso TX</strong>, you already know the hustle. Between managing employees, serving customers, and keeping up with the competition along the Sun City corridor, your financial records can easily slip to the bottom of the priority list. But ignoring your books—even for a single quarter—can snowball into cash-flow crises, missed tax deductions, and decisions based on guesswork instead of data.
      </p>
      <p className="text-gray-600 leading-relaxed mb-6">
        That is exactly <strong>why El Paso small businesses need monthly bookkeeping</strong>. A consistent, professional bookkeeping routine is not a luxury reserved for large corporations. It is the single most effective financial habit any local business owner can adopt to protect profits, reduce stress, and build a company that lasts. Whether you run a family restaurant on Dyer Street, a landscaping crew in the Upper Valley, or an e-commerce brand shipping from the Eastside, monthly bookkeeping gives you the clarity to move forward with confidence.
      </p>
      <p className="text-gray-600 leading-relaxed mb-6">
        In this comprehensive guide we will walk through seven compelling reasons <strong>why El Paso small businesses need monthly bookkeeping</strong>, share real-world examples from the local market, and give you a practical framework for getting started—even if your current books are a mess. Along the way, if you are curious about the digital tools that make monthly bookkeeping faster, take a look at our guide to the <a href="/blog/top-cloud-accounting-softwares" className="text-teal-600 font-medium hover:text-teal-700 underline underline-offset-2 cursor-pointer">top cloud-based accounting platforms built for small businesses</a>.
      </p>

      {/* Table of Contents */}
      <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100 not-prose">
        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-list-ordered text-teal-600 text-xl"></i>
          </div>
          What You Will Learn
        </h3>
        <ol className="space-y-3">
          {[
            "Cash-Flow Visibility: The Lifeblood of Every El Paso Business",
            "Tax Readiness All Year Long—Not Just in April",
            "Catching Errors, Fraud, and Duplicate Charges Early",
            "Better Loan and Credit Applications",
            "Data-Driven Growth Decisions",
            "Staying Compliant With Texas and Federal Requirements",
            "Freeing Up Your Time to Run the Business",
          ].map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="w-7 h-7 bg-teal-100 text-teal-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
                {i + 1}
              </span>
              <span className="text-gray-700 text-sm leading-relaxed">{item}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
